import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { UserPlus } from "@phosphor-icons/react";

export default function Team() {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ email: "", name: "", role: "accountant", password: "" });

  const load = async () => setRows((await api.get("/team")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/team/invite", form);
      toast.success(`${form.name} invited as ${form.role}`);
      setShow(false);
      setForm({ email: "", name: "", role: "accountant", password: "" });
      load();
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  const roleClass = (r) =>
    r === "owner" ? "lb-badge-dark" : r === "accountant" ? "lb-badge-info" : "";

  return (
    <div className="space-y-5 lb-fade" data-testid="team-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Access</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Team & Roles</h1>
          <p className="text-neutral-600 text-sm mt-1">Invite accountants and viewers to your company.</p>
        </div>
        <button className="lb-btn" onClick={() => setShow((s) => !s)} data-testid="team-invite-btn">
          <UserPlus size={14} /> Invite User
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="lb-card p-6 grid grid-cols-4 gap-4">
          <div>
            <label className="lb-label">Name</label>
            <input required className="lb-input" value={form.name}
                   onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="tm-name" />
          </div>
          <div>
            <label className="lb-label">Email</label>
            <input type="email" required className="lb-input" value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="tm-email" />
          </div>
          <div>
            <label className="lb-label">Role</label>
            <select className="lb-select" value={form.role}
                    onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="tm-role">
              <option value="accountant">Accountant (edit)</option>
              <option value="viewer">Viewer (read-only)</option>
            </select>
          </div>
          <div>
            <label className="lb-label">Initial Password</label>
            <input type="password" required minLength={6} className="lb-input" value={form.password}
                   onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="tm-pass" />
          </div>
          <div className="col-span-4 flex gap-2">
            <button className="lb-btn" data-testid="tm-submit">Send Invite</button>
            <button type="button" className="lb-btn lb-btn-ghost" onClick={() => setShow(false)}>Cancel</button>
          </div>
        </form>
      )}

      <div className="lb-card">
        <table className="lb-table">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th></tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.user_id}>
                <td className="font-semibold">{m.name}</td>
                <td className="text-sm">{m.email}</td>
                <td><span className={"lb-badge " + roleClass(m.role)}>{m.role}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
